
export const ACCEPT_IMAGES_EXTENSION = ["png", "jpeg", "jpg", "webp"];

export const ACCEPT_PDF_EXTENSION = ["pdf"];

export const ACCEPT_VIDEO_EXTENSION = ["mp4"];

export const ACCEPT_IMAGES_TYPES_OBJECT = {
  "image/jpeg": [],
  "image/png": [],
  "image/webp": [],
  "image/jpg": [],
};

export const ACCEPT_VIDEO_TYPES_OBJECT = {
  "video/mp4": [],
};
export const ACCEPT_PDF_TYPES_OBJECT = {
  "application/pdf": [],
};

export const MAX_SIZE_IMAGE = 10 * 1_048_576;
export const MAX_SIZE_VIDEO = 360 * 1_048_576;
export const MAX_SIZE_PDF = 5 * 1_048_576;

export const SOCIAL_MEDIA_DATA = {
  facebook: {
    link: "https://www.facebook.com/p/%D8%B8%D9%84-Dhell-100063834879165/?locale=hi_IN&paipv=0&eav=Afaa-MiXAidahyYTV5zxdvn0aEzEOzOWhrFIjBM-GUklpnCypF00tNuqMUKjILL0En8&_rdr",
  },
  twitter: {
    link: "https://twitter.com/dhell_center?lang=ar",
  },
  instagram: {
    link: "https://www.instagram.com/dhell_center/",
  },
};


export const LINKS_DATA = [
  {
    path: "/",
    nameAr: "الرئيسية"
  },
  {
    path: "/our_services",
    nameAr: "خدماتنا"
  },
  {
    path: "/find-specialist",
    nameAr: "الأخصائيين"
  },
  {
    path: "/aboutus",
    nameAr: "من ظل؟"
  },
  {
    path: "/contact-us",
    nameAr: "تواصل معنا"
  },
]


export const childConditionOptions = [
  { value: "", label: "اختر حالة الطفل من القائمة", isDisabled: true },
  { value: "إعاقة عقلية", label: "إعاقة عقلية" },
  { value: "إعاقة سمعية", label: "إعاقة سمعية" },
  { value: "إعاقة بصرية", label: "إعاقة بصرية" },
  { value: "إعاقة حركية", label: "إعاقة حركية" },
  { value: "صعوبات تعلم", label: "صعوبات تعلم" },
  { value: "توحد", label: "توحد" },
  { value: "متلازمة داون", label: "متلازمة داون" },
  { value: "تدخل مبكر", label: "تدخل مبكر" },
  { value: "تأخر لغوي", label: "تأخر لغوي" },
  { value: "other", label: "اخرى (اذكرها...)" },
];

export const districtOptions = [
  { value: "", label: "اختر الحي", isDisabled: true },
  { value: "حي 1", label: "حي 1" },
  { value: "حي 2", label: "حي 2" },
];
export const cityOptions = [
  { value: "", label: "اختر المدينة", isDisabled: true },
  { value: "مدينة1", label: "مدينة1" },
  { value: "مدينة2", label: "مدينة2" },
];

export const specializationOptions = [
  { value: "", label: "الكل", isDisabled: true },
  { value: "تربية خاصة", label: "تربية خاصة" },
  { value: "نطق وتخاطب", label: "نطق وتخاطب" },
  { value: "تمريض", label: "تمريض" },
  { value: "علم نفس", label: "علم نفس" },
  { value: "علم اجتماع", label: "علم اجتماع" },
  { value: "علاج طبيعي", label: "علاج طبيعي" },
  { value: "علاج وظيفي", label: "علاج وظيفي" },
];

export const yearsOfExperienceOptions = [
  { value: "", label: "اختر سنوات الخبرة", isDisabled: true },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const degreeOptions = [
  { value: "", label: "اختر الدرجة العلمية", isDisabled: true },
  { value: "دكتوراة", label: "دكتوراة" },
  { value: "بكالوريوس", label: "بكالوريوس" },
  { value: "ماجستير", label: "ماجستير" },
  { value: "دبلوم", label: "دبلوم" },
];
